import { tokens as dataChipTokens } from '@pkg/components/DataChip/tokens';

const assetCardPadding = 16;

export const tokens = {
    padding: assetCardPadding,
    radius: 16,
    row: {
        // TODO: We should instead use either an `Accordion` or `framer-motion`.
        expandedHeight: dataChipTokens.chip.height * 2 + dataChipTokens.list.gap + assetCardPadding,
    },
    errorMessage: {
        fontSize: 14,
    },
};
